<template>
  <div class="messageList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 状态select -->
        <el-form-item :label="$t('lang.lab_readStatus')">
          <el-select v-model="readStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_readStatus')">
            <el-option
              v-for="(item,index) in status"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 类型select -->
        <el-form-item :label="$t('lang.lab_messageType')">
          <el-select v-model="messageType" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_messageType')">
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 标题input -->
        <el-form-item :label="$t('lang.lab_messageTitle')">
          <input style="display: none"/>
          <el-input v-model="title" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_messageTitle')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <!-- 全部标记已读 -->
      <el-button type="primary" slot="header" @click="onRead">{{$t('lang.btn_read')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_number')" width="100px" sortable></el-table-column>
        <!-- 标题 -->
        <el-table-column prop="title" :label="$t('lang.lab_title')"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="readStatus" :label="$t('lang.lab_readStatus')">
          <template slot-scope="scope">
            <!-- 0: 未读 -->
            <span v-if="scope.row.readStatus === 0">{{$t('lang.Message_status[1].name')}}</span>
            <!-- 1: 已读 -->
            <span v-if="scope.row.readStatus === 1">{{$t('lang.Message_status[2].name')}}</span>
          </template>          
        </el-table-column>
        <!-- 时间 -->
        <el-table-column prop="messageTime" :label="$t('lang.lab_messageTime')">
          <template slot-scope="scope">
            {{ scope.row.messageTime  | time }}
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onDetail(scope.row)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 查看 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      class="form-position"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" ref="form" label-width="120px" label-suffix=":">
        <!-- 消息时间 -->
        <el-form-item :label="$t('lang.lab_messageTimes')">
          <span>{{ form.messageTime | time }}</span>
        </el-form-item>
        <!-- 消息类型 -->
        <el-form-item :label="$t('lang.lab_messageTypeName')">
          <span>{{ form.messageTypeName }}</span>
        </el-form-item>
        <el-divider></el-divider>
        <!-- 标题 -->
        <el-form-item :label="$t('lang.lab_messageTitle')">
          <span>{{ form.title }}</span>
        </el-form-item>
        <!-- 赛事名称 -->
        <el-form-item :label="$t('lang.lab_competeName')">
          <span>{{ form.competeName }}</span>
        </el-form-item>
        <!-- 赛事项目-线上赛无赛事项目(competeTyp:0线下1线上) -->
        <el-form-item :label="$t('lang.lab_competeItem')"  v-if="form.competeType === 0">
          <span>{{ form.competeItemName }}</span>
        </el-form-item>
        <!-- 缴纳费用 -->
        <el-form-item :label="$t('lang.lab_fee')">
          <span>{{ form.fee }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="toComfirm">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:messageList
 *@Description:我的消息
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-18
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 查看dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_detail'), // 查看dialog的title
      /* 我的消息列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      status: this.$i18n.t('lang.Message_status'), // 状态下拉list
      types: this.$i18n.t('lang.Message_messageType'), // 类型下拉list
      readStatus: '', // 筛选-状态
      messageType: '', // 筛选-类型
      title: '', // 筛选-标题
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 记忆筛选项值 */
      readStatus_bak: '', // 备份-状态
      messageType_bak: '', // 备份-类型
      title_bak: '', // 备份-标题
      form: {
        id: '',
        competeItemName: '',
        competeName: '',
        fee: '',
        messageTime: '',
        messageType: '',
        messageTypeName: '',
        readStatus: '',
        title: '',
        competeType: 0,      
      }, // 详细数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取我的消息列表
    getData() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize        
      }
      this.$postJson('/message/filterMessage', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.readStatus_bak = this.readStatus
        this.messageType_bak = this.messageType
        this.title_bak = this.title
      } else { 
        // 筛选项正确显示
        this.readStatus = this.readStatus_bak
        this.messageType = this.messageType_bak
        this.title = this.title_bak
      }
      let params = {
        readStatus: this.readStatus,
        messageType: this.messageType,
        title: this.title,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,
        pageNum: this.pageNum,
        pageSize: this.pageSize        
      }
      this.$postJson('/message/filterMessage', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.readStatus = ''
      this.messageType = ''
      this.title = ''
      this.readStatus_bak = ''
      this.messageType_bak = ''
      this.title_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/message/message/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 全部标记已读
    onRead() {
      this.$postJson('/message/readAllStatus').then(
        res => {
          if (res && res.code === 200) {
            // 更新列表
            this.pageNum = 1
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )     
    },
    // 查看
    onDetail(data) {
      console.log('onDetail', data)
      this.form.competeType = data.competeType
      this.form.id = data.id
      this.form.competeItemName = data.competeItemName
      this.form.competeName = data.competeName
      this.form.fee = data.fee + this.$i18n.t('lang.lab_yuan')
      this.form.messageTime = data.messageTime
      this.form.messageType = data.messageType
      this.form.messageTypeName = data.messageTypeName
      this.form.readStatus = data.readStatus
      this.form.title = data.title 
      this.isShow = true
      this.$get(`/message/readStatus?sysMessageId=${this.form.id}`).then(
        res => {
          if (res && res.code === 200) {
            // 更新列表
            this.onSearch(false, false)
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )     
    },
    // 确定
    toComfirm() {
      this.handleDialogClosed()
    },
    // 监听关闭'查看'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.form.competeType = ''
      this.form.id = ''
      this.form.competeItemName = ''
      this.form.competeName = ''
      this.form.fee = ''
      this.form.messageTime = ''
      this.form.messageType = ''
      this.form.messageTypeName = ''
      this.form.readStatus = ''
      this.form.title = ''   
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
.messageList{
  .form-position{
    .el-dialog .el-form {
      padding: 20px 20px 0 20px !important;
    }
  }
}
</style>
